import LocalizedStrings from 'localized-strings';

import { VerificationStepCategory } from 'features/Onboarding/modules/Verification/lib/steps/types';

export default new LocalizedStrings({
  en: {
    stepErrorFallback: 'This step requires your attention',
    subtitle: {
      complete: 'Complete',
      remainingTasksPlural: '{count} tasks to complete',
      remainingTasksSingular: '{count} task to complete',
    },
    title: {
      [VerificationStepCategory.CompanyInfo]: 'Information about your company',
      [VerificationStepCategory.PersonalInfo]: 'Personal information',
      [VerificationStepCategory.ShineOffer]: 'Shine offers',
    },
  },

  fr: {
    stepErrorFallback: 'Cette étape nécessite votre attention',
    subtitle: {
      complete: 'Complété',
      remainingTasksPlural: '{count} tâches à compléter',
      remainingTasksSingular: '{count} tâche à compléter',
    },
    title: {
      [VerificationStepCategory.CompanyInfo]:
        'Informations de votre entreprise',
      [VerificationStepCategory.PersonalInfo]: 'Informations personnelles',
      [VerificationStepCategory.ShineOffer]: 'Offres Shine',
    },
  },
} as const);
